(function () {
    'use strict';

    // @ngInject
    function IntercomServiceCtor($injector, Intercom, AppConfigService, FeaturesService, moment, WorkspaceFileService, Enums) {
        this.Intercom = Intercom;
        this.AppConfigService = AppConfigService;
        this.FeaturesService = FeaturesService;
        this.moment = moment;
        this.WorkspaceFileService = WorkspaceFileService;
        this.Enums = Enums;
    }

    Services.IntercomService = Class({

        constructor: IntercomServiceCtor,

        init: function init(user) {
            this.user = user;
            this._constructListeners();
        },

        identify: function identify(extraArgs) {

            if (!this.shouldUseIntercom(this.user)) {
                return;
            }

            var basicArgs = {
                app_id: this.AppConfigService.appConfiguration().intercom_app_id,
                widget:{
                    activator: "#hb-intercom"
                }
            };

            if (this.user && !this.user.isEmpty()) {
                this.shutdown();
                this._boot(this.user, angular.extend(basicArgs, this._getUserAttributes(this.user), (extraArgs || {})));
            }
        },

        shutdown: function shutdown() {
            if (!this.shouldUseIntercom(this.user)) {
                return;
            }
            this.Intercom.then(function(intercom) {
                intercom('shutdown');
            });
        },

        shouldUseIntercom: function shouldUseIntercom(user) {
            return user && user.isVendor();
        },

        _boot: function _boot(user, args) {
            if (!this.shouldUseIntercom(user)) {
                return;
            }

            this.Intercom.then(function(intercom) {
                intercom('boot', args);
            });
        },

        _getUserAttributes: function _getUserAttributes(user) {

            var args = {
                user_id: user._id,
                email: user.email,
                fullName: user.full_name,
                firstName: user.first_name,
                phone: user.phone_number,
                lastName: user.last_name,
                name: user.full_name,
                user_type: user.system_user_type,
                job_title: user.job_title,
                user_job_title: user.user_type_name,
                user_hb_system_type: user.hb_user_type,
                is_subscribed: user.companyHasSubscription(),
                first_login: this._asDate(user.first_login),
                last_login: this._asDate(user.last_login_time),
                bank_information_entered: !!user.myBankAccount(),
                gmail_status: user.google_integrations && user.google_integrations.length ? 'active' : 'inactive',
                first_payable_file_sent: !!user.last_file_sent_time,
                cancellation_reason: '',
            };

            if (user.is_hb_admin){
                args.user_is_hb_admin = true;
            }

            if (user.activated_on) {
                args.activated_date_from_product = this._asDate(user.activated_on);
            }

            if (user.isVendor() && user.company) {
                args.company_id = user.company_id;
                args.user_company_type = user.company.company_type_name;
                args.user_company_name = user.company.company_name;
                args.currency = user.company.currency;
                args.user_company_team_members_count = user.company.team_members && user.company.team_members.length;
                args.user_company_email = user.company.email;
                args.user_company_state = user.company.state;
                args.user_company_city = user.company.city;
                args.has_multi_brands = !!user.company.account.has_multi_brands;

                if (user.company.owner) {
                    args.user_company_owner_email = user.company.owner.email;
                    args.user_company_owner_id = user.company.owner._id;
                }
            }

            return args;
        },

        _asDate: function _asDate(date) {
            return this.moment(date).format('MM/DD/YY');
        },

        _constructListeners: function _constructListeners() {
            this.user.on(this.Enums.PubSubTriggers.firstPayableFileSent, this.identify.bind(this));

            this.user.on(this.Enums.PubSubTriggers.membershipCanceled, function onMembershipCanceled(data) {
                this.identify({cancellation_reason: data.reason});
            }.bind(this));
        }
    });
}());
